export default theme => ({

  title: {
    color: '#ffffff',
    flex: 1,
    textAlign: 'left'
  },

  icon: {
    marginRight: theme.spacing.unit
  },

  navIcon: {
    marginRight: theme.spacing.unit,

    [theme.breakpoints.up('lg')]: {
      display: 'none',
    }
  },

  drawerPaper: {
    marginTop: theme.spacing.unit * 7,
    paddingTop: theme.spacing.unit * 3,
    width: theme.qborder.drawer.width,
  }

});



// WEBPACK FOOTER //
// ./src/styles/components/Header.js